import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';

class Loading extends React.Component{

    render(){   
        return (
            <span>
                <CircularProgress style={{height: 20, width: 20, marginLeft: 10, marginRight: 10}}/>
            </span>
        );

    }
}

export default Loading